import{styled as t}from"@mui/material/styles";const o=t("section",{name:"ProductCards",slot:"section"})({maxWidth:"100%"});export{o as Wrapper};
//# sourceMappingURL=styles.js.map
